export function getSuffixOptions() {
  return [
    { label: '', value: '' }, // Blank option for (None)
    { label: 'Jr.', value: 'Jr.' },
    { label: 'Sr.', value: 'Sr.' },
    { label: 'III', value: 'III' },
    { label: 'IV', value: 'IV' },
  ];
}

export function getTitleOptions() {
  return [
    { label: '(None)', value: '' }, // Blank option for filters and forms
    { label: 'Dr.', value: 'Dr.' },
    { label: 'Mr.', value: 'Mr.' },
    { label: 'Ms.', value: 'Ms.' },
    { label: 'Mrs.', value: 'Mrs.' },
    { label: 'Miss', value: 'Miss' },
    { label: 'Mx.', value: 'Mx.' },
  ];
}